export const aboutPageContent = {
  titleCn: '关于析莜',
  titleEn: 'About XIYOO',
  description:
    '析莜科技（XIYOO）专注为国际企业、制造业、金融及零售电商行业提供企业级财务数智化整体解决方案。依托领先技术架构与行业经验，通过智能化技术，聚焦于财务领域最重要也是最繁杂的业务管理方向，采用软硬件一体手段，实现企业资金全面集中管控，高效完成企业资金账户全覆盖、解析全自动、数据标准化、动态监控、及时更新、精细管理、个性适配。帮助企业更好实现资金"看得见""管的住""用的好"。',
  heroImage:
    'https://readdy.ai/api/search-image?query=Modern%20minimalist%20corporate%20office%20interior%2C%20dark%20moody%20atmosphere%20with%20clean%20lines%2C%20glass%20and%20concrete%20architecture%2C%20subtle%20warm%20lighting%20accents%2C%20professional%20business%20environment%2C%20no%20holograms%20no%20glowing%20screens%2C%20restrained%20and%20elegant%20photography&width=1200&height=500&seq=about-hero-01&orientation=landscape',
  stats: [
    { label: '10年+', subLabel: '行业服务经验' },
    { label: '300+', subLabel: '知名客户往来' },
    { label: '>98%', subLabel: '客户满意度' },
  ],
  cities: ['上海', '南京', '深圳', '香港'],
  certificates: [
    {
      title: '质量管理体系 ISO27001',
      desc: '信息安全管理体系认证，保障客户数据安全与隐私保护',
    },
    {
      title: '国家高新技术企业',
      desc: '获得国家高新技术企业认定，具备核心技术自主研发能力',
    },
    {
      title: '上海信息网络安全管理协会会员单位',
      desc: '加入上海市信息网络安全管理协会，持续推动行业安全标准化',
    },
    {
      title: 'UiPath 代理证书',
      desc: '成为 UiPath 官方合作伙伴，为企业 RPA 流程自动化提供专业服务',
    },
    {
      title: '软件著作权',
      desc: '拥有多项软件著作权登记，核心技术完全自主知识产权',
    },
  ],
  features: [
    {
      icon: 'ri-brain-line',
      title: 'AI 智能化',
      desc: 'NLP 自然语言处理、OCR 光学字符识别、RPA 流程自动化，赋能企业智能化升级',
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: '资金安全管理',
      desc: '网银盾智管平台与 CloudUSB 系列服务器，提供国密级安全认证与硬件保护',
    },
    {
      icon: 'ri-funds-line',
      title: '资金可视化',
      desc: '网银业务智管平台实现企业资金全面集中管控，账户全覆盖、数据标准化',
    },
    {
      icon: 'ri-award-line',
      title: '行业权威认证',
      desc: '通过 ISO27001、CCC 认证与等保三级安全测评，获得国家高新技术企业认定',
    },
  ],
};